<template>
  <div>
    <b-container class="navigationContainer">
      <div
        v-if="statusPageInfo && statusPageInfo.status"
        class="floating-element"
      >
        <b>Status: </b> {{ statusPageInfo.status }}
        <br>
        <b>Version: </b> {{ statusPageInfo.version }}
        <br>
        <b>Veröffentlichung: </b> {{ statusPageInfo.releaseDate.split("T")[0] }}
      </div>
      <the-navigation />
    </b-container>
    <b-container>
      <slot />
    </b-container>
    <b-container class="bv-example-row">
      <b-row class="text-center">
        <b-col class="text-light">
          <small>{{ gitVersion }}</small>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import TheNavigation from "@/components/navigation/TheNavigation.vue";
import { IsUserLoggedIn, GetStatuspageInfo } from "@/services/user.service.js";

export default {
  components: {
    TheNavigation,
  },
  data() {
    return {
      isUserLoggedIn: false,
      pathName: "",
      isIntEnvironment: false,
      statusPageInfo: {},
    };
  },
  computed: {
    gitVersion() {
      return process.env.GIT_VERSION;
    },
    gitHash() {
      return process.env.GIT_HASH.substring(0, 6);
    },
  },
  created() {
    //Check if the environment is INT
    const url = process.env.VUE_APP_BASE_API_URL;
    this.isIntEnvironment = url.includes("int");

    if (this.isIntEnvironment) {
      GetStatuspageInfo(
        (result) => {
          if (result) {
            this.statusPageInfo = result;
          }
        },
        () => {},
      );
    }
  },
  mounted() {
    this.pathName = window.location.pathname.toLowerCase();
    this.isUserLoggedIn = IsUserLoggedIn();
    if (!this.isUserLoggedIn && this.pathName != "/login") {
      this.$router.push({
        path: "/login?source=" + this.$route.fullPath,
        query: { source: this.$route.path },
      });
    }
  },
};
</script>

<style>
.floating-element {
  position: fixed; /* Das Element bleibt beim Scrollen sichtbar */
  top: 7%;
  right: 1%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 20px;
  border: 1px solid #ccc;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

a {
  color: red;
}

/* Background set to white */
.theme--light.application {
  background: white;
}

.btn,
.custom-select,
.form-control,
.page-link {
  border-radius: 0px !important;
}

.navigationContainer {
  max-width: 1400px;
}

.container {
  padding-left: 24px;
  padding-right: 24px;
}

@media only screen and (min-width: 1904px) {
  .container {
    max-width: 1400px;
  }
}
</style>
